experimentalFragmentVariables